import { createContext, useContext, useEffect, useState } from "react";
import { callAPI, Method } from "../commonFunctions/CommonFunctions";

interface AppSettings {
    theme: any;
    gst: {
        enableGST: boolean;
        enableHSNSACCode: boolean;
    };
    payment: {
        defaultPaymentMethod: string;
    };
    receiptSetting: any;
}

const AppSettingsContext = createContext<any>(null);

export const useAppSettings = () => {
    return useContext(AppSettingsContext);
};

export const AppSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [settings, setSettings] = useState<AppSettings | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchSettings = async () => {
        try {
            const res = await callAPI("Vyapar/AppSetting", Method.GET);
            setSettings(res);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const updateSettings = async (newSettings: AppSettings) => {
        try {
            setLoading(true);
            const res = await callAPI("Vyapar/AppSetting", Method.PUT, newSettings);
            setSettings(res);
            return res;
        } catch (error) {
            console.error('failed to save settings');
            throw error;
        }finally{
            setLoading(false);
        }
    };

    return (
        <AppSettingsContext.Provider value={{ settings, updateSettings, loading }}>
            {children}
        </AppSettingsContext.Provider>
    );
};